<template>
  <div>
    <PolizaDataIndex
      @getData="$emit('getData')"
      :polizaInfo="polizaInfo"
      :productos="productos"
    />

    <IndexPolizaLog
      :polizaInfo="customData"
      :productos="productos"
    />
  </div>
</template>

<script>
import PolizaDataIndex from "./PolizaData/PolizaDataIndex.vue";
import IndexPolizaLog from "./PolizaLog/IndexPolizaLog.vue";

export default {
  components: {
    PolizaDataIndex,
    IndexPolizaLog
  },

  data() {
    return {};
  },
  props: {
    polizaInfo: {
      type: Object,
      default: () => {},
    },
    productos: {
      type: Array,
      default: () => [],
    },
    ramoData: {
      type: Object,
      default: () => {},
    },
    customData: {
      type: Object,
      default: () => [],
    },
  },
  methods: {},
};
</script>
